export const uploadPortal = async (token: any, blob: any, boundary: any) => {
  const authToken = token;
  const { gcpBaseURL } = (window as any).data.auth;
  const res = await fetch(`${gcpBaseURL}`, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  }).then(async (res) => {
    const data = await res.json();
    if (res.status === 200) {
      const response = await fetch(`${data.url}`, {
        method: "POST",
        body: blob,
        headers: {
          Authorization: `Bearer ${data.gcp_token}`,
          "Content-Type": `multipart/related; type="application/dicom"; boundary=${boundary}`
        }
      });
      return response;
    }
  });
  return res;
};